import { render, staticRenderFns } from "./BookingCalendar.vue?vue&type=template&id=22207568&scoped=true&"
import script from "./BookingCalendar.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookingCalendar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BookingCalendar.vue?vue&type=style&index=0&id=22207568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22207568",
  null
  
)

export default component.exports